// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fe239f9c","732":"2e50ff6b","977":"abca636d"}[chunkId] + ".chunk.js";
};